import {CSSProperties} from 'react';
import {Person} from '../lib/interfaces';

interface PersonInfoProps {
  person: Person;
  style?: CSSProperties;
}

const PersonInfo = ({person, style}: PersonInfoProps) => {
  return (
    <div style={style}>
      {person.personalIdentityNumber && <p>{person.personalIdentityNumber}</p>}
      <p>{person.email}</p>
      <p>{person.phone}</p>

      {person.personExtended && (
        <div>
          <p>{person.personExtended.firstName ?? ''}</p>
          <p>{person.personExtended.lastName ?? ''}</p>
          <p>{`${person.personExtended.address ?? ''} ${person.personExtended.zipCode ?? ''} ${
            person.personExtended.city ?? ''
          }`}</p>
          <p>{person.personExtended.country ?? ''}</p>
          <p>{person.personExtended.dateOfBirth ?? ''}</p>
        </div>
      )}
    </div>
  );
};

export default PersonInfo;
